import { render, staticRenderFns } from "./CompanyDesktopMultiTopup.vue?vue&type=template&id=ca3c8562"
import script from "./CompanyDesktopMultiTopup.vue?vue&type=script&lang=js"
export * from "./CompanyDesktopMultiTopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports